import { Divider, Flex } from "@chakra-ui/react";
import { Navigate, Outlet } from "react-router-dom";
import useAuthState from "../../state/auth.state";
import Navbar from "./Navbar";

function AppLayout() {
  const { user } = useAuthState();

  if (!user) {
    return <Navigate to="/" />;
  }

  return (
    <div>
      <Navbar authenticated={true} />
      <Divider />
      <Flex mb={16}>
        <Outlet />
      </Flex>
    </div>
  );
}

export default AppLayout;
